import { render, staticRenderFns } from "./AccountBalanceIcon.vue?vue&type=template&id=02c6763b&scoped=true&"
var script = {}
import style0 from "./AccountBalanceIcon.vue?vue&type=style&index=0&id=02c6763b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c6763b",
  null
  
)

export default component.exports